module.exports = __webpack_public_path__ + "static/media/lykke04.82d5560f.jpg";